import { useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";

function Pretest() {
  let params = useParams();
  const navigate = useNavigate();
  const { state } = useLocation();
  const [checkboxVal, setCheckboxVal] = useState(false);
  const [seconds, setSeconds] = useState(0);

  return (
    <>
      <div className="bg-zinc-800 text-slate-200 py-2 px-32 md:px-12">
        <p className="text-xl font-semibold my-2">{state.nameCap}</p>
      </div>
      <form className="rounded-lg border-solid border border-slate-200 my-2 w-4/12 shadow-md p-2 mx-auto mt-24 xsm:mx-auto xsm:my-5 xsm:w-10/12 lg:w-8/12">
        <h2 className="font-semibold text-2xl mb-3">Options</h2>
        <div className="flex justify-between">
          <label>Add Time:</label>
          <input
            type="checkbox"
            onChange={(e) => {
              setCheckboxVal(!checkboxVal);
            }}
          />
        </div>
        <div className="flex justify-between">
          <label for="set_seconds">Time Per Question In Seconds:</label>
          {checkboxVal ? (
            <input
              className="border border-slate-300 mt-1 mb-3 xsm:w-2/12"
              id="set_seconds"
              type="number"
              onChange={(e) => {
                setSeconds(+e.target.value);
              }}
            ></input>
          ) : (
            <input
              className="border border-slate-300 mt-1 mb-3 xsm:w-2/12"
              id="set_seconds"
              type="number"
              disabled
            ></input>
          )}
        </div>
        <div className="flex justify-end">
          <button
            className="w-2/12 text-white bg-red-400 border-solid border border-neutral-50 rounded p-1 hover:bg-red-500 md:w-4/12"
            onClick={(e) => {
              e.preventDefault();

              navigate(-1);
            }}
          >
            Back
          </button>
          <button
            className="w-2/12 text-white bg-green-400 border-solid border border-neutral-50 rounded p-1 whitespace-nowrap hover:bg-green-500 md:w-4/12"
            onClick={(e) => {
              e.preventDefault();

              navigate(`/dashboard/set/test/${params.setname}`, {
                state: {
                  seconds,
                  nameCap: state.nameCap,
                },
              });
            }}
          >
            Start Test
          </button>
        </div>
      </form>
    </>
  );
}
export default Pretest;
